// @ts-nocheck

import { chunk, padStart, padEnd } from 'lodash';

import { Locales } from '../../../types/common';
import { getQuerystringParam } from '../../../utils/index';

const decbin = (number) => {
  //  discuss at: https://locutus.io/php/decbin/
  // original by: Enrique Gonzalez
  // bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
  // improved by: https://stackoverflow.com/questions/57803/how-to-convert-decimal-to-hex-in-javascript
  //    input by: pilus
  //    input by: nord_ua
  //   example 1: decbin(12)
  //   returns 1: '1100'
  //   example 2: decbin(26)
  //   returns 2: '11010'
  //   example 3: decbin('26')
  //   returns 3: '11010'

  if (number < 0) {
    number = 0xffffffff + number + 1;
  }
  return parseInt(number, 10).toString(2);
};

// url use by https://www.pronosoft.com/ to autocomplete a grid
// ex: https://www.dev.winamax.fr/paris-sportifs/grilles/grille7-1944?c4s=MMkUUkUhSSRiUkhMhMkMkhRkUJSk
export const parsePreChecksFromUrl = (matchCount) => {
  const c4s = getQuerystringParam('c4s') || null;
  if (c4s) {
    const nc4s = c4s.replace('-', '+');
    const chunks = chunk(nc4s, 4);
    let binaryString = '';
    try {
      binaryString = chunks.reduce((acc, cur) => {
        const chars = atob(padEnd(cur.join(''), 4, 'A')).split('');
        const home = padStart(decbin(chars[0].charCodeAt(0)), 8, '0');
        const nul = padStart(decbin(chars[1].charCodeAt(0)), 8, '0');
        const ext = padStart(decbin(chars[2].charCodeAt(0)), 8, '0');
        return `${acc}${home}${nul}${ext}`;
      }, '');
    } catch (err) {
      console.error(err);
    }
    if (binaryString !== '') {
      const checks = chunk(binaryString, 3 * matchCount);
      const preChecks = [];
      checks.forEach((check) => {
        const strCheck = check.join('');
        if (strCheck.match(/^([01]*1+[01]*)$/)) {
          preChecks.push(strCheck);
        }
      });
      return preChecks;
    }
  }
  return null;
};

export const isGridsAllowed = (lang) => lang === Locales.FR;
